import React from 'react';
import { renderRoutes } from 'react-router-config';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import Separator, { Breakpoint } from '@wix/da-shared-react/pkg/Separator';
import SubSubNavBar from '../../SubSubNavBar';
import ShopAll from './ShopAll';
import ShopCommissions from './ShopCommissions';
import ShopPrints from './ShopPrints';
import ShopPremiumContent from './ShopPremiumContent';
import ShopPremiumFolders from './ShopPremiumFolders';
import ShopDas from './ShopDas';

import s from './ShopSection.scss';

export interface Props {
  profileOwnerUser: PapiUser;
  total: {
    all: number;
    commissions: number;
    premiumContent: number;
    premiumFolders: number;
    prints: number;
    das?: number;
  };
}

class ShopSection extends React.Component<Props & WithTranslation> {
  render() {
    return (
      <div className={s['root']}>
        <SubSubNavBar
          className={s['section-nav']}
          items={this.getShopRoutes()}
        />
        <Separator
          className={s['separator']}
          forBreakpoint={Breakpoint.Mobile}
        />
        <div>{renderRoutes(this.getShopRoutes())}</div>
      </div>
    );
  }

  getShopRoutes = () => {
    const { t, total } = this.props;
    const { username: ownerUsername } = this.props.profileOwnerUser;
    const username = ownerUsername.toLowerCase();
    return [
      {
        label: t('common.all'),
        count: total.all,
        path: Url.userShopPath(username, USER_PROFILE_SHOP_SUB_PATHS.ALL),
        component: ShopAll,
        exact: true,
        bi_item_label: 'all',
      },
      {
        label: 'Digital Assets',
        count: total.das,
        path: Url.userShopPath(username, 'digital_assets' as any),
        component: ShopDas,
        bi_item_label: 'digital_assets',
      },
      {
        label: t('common.premiumFolders'),
        count: total.premiumFolders,
        path: Url.userShopPath(
          username,
          USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS
        ),
        component: ShopPremiumFolders,
        bi_item_label: USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS,
      },
      {
        label: t('common.commissions_plural'),
        count: total.commissions,
        path: Url.userShopPath(
          username,
          USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS
        ),
        component: ShopCommissions,
        bi_item_label: USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS,
      },
      {
        label: t('common.prints_plural'),
        count: total.prints,
        path: Url.userShopPath(username, USER_PROFILE_SHOP_SUB_PATHS.PRINTS),
        component: ShopPrints,
        bi_item_label: USER_PROFILE_SHOP_SUB_PATHS.PRINTS,
      },
      {
        label: t('common.premiumContent'),
        count: total.premiumContent,
        path: Url.userShopPath(
          username,
          USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT
        ),
        component: ShopPremiumContent,
        bi_item_label: USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT,
      },
    ];
  };
}

export default withTranslation()(ShopSection) as React.ComponentType<Props>;
